

















































































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Message, SearchCondition } from '@/modules/message';
import { MessageTypes, getMessageTypeName } from '@/enums/messageTypes';
import { PublicTypes, getPublicTypeName } from '@/enums/publicTypes';
import { ReadTypes, getReadTypeName } from '@/enums/readTypes';
import { FunctionTypes } from '@/enums/functionTypes';
import AvaivaledVue from '@/components/avaivaled.vue';

@Component
export default class MessageList extends AvaivaledVue {
  private MessageTypes = MessageTypes;
  private getMessageTypeName = getMessageTypeName;
  private PublicTypes = PublicTypes;
  private getPublicTypeName = getPublicTypeName;
  private ReadTypes = ReadTypes;
  private getReadTypeName = getReadTypeName;
  private showSearchCondition = true;

  @Prop() private searchCondition: string;

  @Watch('searchCondition')
  private changeSearchCondition() {
    this.setSearchCondition();
    this.loadData();
  }

  get loading(): boolean {
    return this.$store.state.message.loading;
  }

  get countAll(): number {
    if (this.$store.state.message.countAll === 0) {
      return 1;
    } else {
      return this.$store.state.message.countAll;
    }
  }

  get messageList(): Message[] {
    return this.$store.state.message.messageList;
  }

  get condition(): SearchCondition {
    return this.$store.state.message.searchCondition;
  }

  get isMini(): boolean {
    return (this as any).$mq === 'mini';
  }

  private mounted() {
    this.setSearchCondition();
    this.loadData();
  }

  private deactivated() {
    this.$destroy();
  }

  private created() {
    this.pageBackCheck(FunctionTypes.Message);
  }

  private setSearchCondition() {
    if (!!this.searchCondition) {
      const condition = JSON.parse(this.searchCondition) as SearchCondition;
      this.condition.publicType = condition.publicType;
      this.condition.readType = condition.readType;
      this.condition.tutorIdList = condition.tutorIdList;
      this.condition.dateFrom = condition.dateFrom;
      this.condition.dateTo = condition.dateTo;
      this.condition.keyWord = condition.keyWord;
      this.condition.page = 1;
      this.condition.sort = condition.sort;
    }
  }

  private loadData() {
    this.$store.dispatch('message/searchMessages', this.condition);
  }

  private getRowNumber(index: number) {
    return this.condition.perPage * (this.condition.page - 1) + index + 1;
  }

  private sendDateFormatter(row: Message) {
    if (!row.sendDate) {
      return '';
    } else {
      return (this as any).$moment(row.sendDate).format('YYYY/MM/DD');
    }
  }

  private updateDateFormatter(row: Message) {
    if (!row.updateDate) {
      return '';
    } else {
      return (this as any).$moment(row.updateDate).format('YYYY/MM/DD H:mm');
    }
  }

  private onChangeCondition() {
    this.condition.page = 1;
    this.loadData();
  }

  private onChangePage() {
    this.loadData();
  }

  private onChangeSort({ prop, order }: any) {
    if (!prop) {
      this.condition.sort = 'updateDate descending';
    } else {
      this.condition.sort = `${prop} ${order}`;
    }
    this.loadData();
  }

  private onPageSizeChange(val: number) {
    this.condition.perPage = val;
  }

  private onRowClick(row: Message) {
    this.$router.push({
      name: 'MessageDetails',
      params: {
        messageId: row.id
      }
    });
  }

  private onCreateReport() {
    this.$router.push({ name: 'MessageCreate' });
  }
}
